// extracted by mini-css-extract-plugin
export var paginationContainer = "carouselPagination-module--paginationContainer--3Ciw_";
export var indicator = "carouselPagination-module--indicator--12KYd";
export var indicatorActive = "carouselPagination-module--indicatorActive--1OCrt";